import { render } from "./CloverCardInfo.vue?vue&type=template&id=23b4c3a0&scoped=true"
import script from "./CloverCardInfo.vue?vue&type=script&lang=js"
export * from "./CloverCardInfo.vue?vue&type=script&lang=js"

import "./CloverCardInfo.vue?vue&type=style&index=0&id=23b4c3a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b4c3a0"]])

export default __exports__